export const buildEditableUserPayload = userState => {
  const payload = {
    email: userState.email,
    provider: userState.provider,
    type: userState.type,
  }

  if (userState.configurationId) {
    payload.configurationId = userState.configurationId
  }

  if (userState.provider === 'password' && userState.password) {
    payload.password = userState.password
  }

  return payload
}
